import { PHTaxIssueOptions } from '../../enums';
import { GenericCheckboxStep } from '../steps';

function PHTaxIssuesStep() {
  return (
    <GenericCheckboxStep
      title="What kind of tax issue are you dealing with?"
      subtitle="Select all that apply."
      checkboxOptions={PHTaxIssueOptions}
      referralFieldName="ph_tax_issues"
    />
  );
}

export { PHTaxIssuesStep };
